export default __webpack_public_path__ + "static/media/aprovar.74c7653d.svg";